import React from 'react';
import PropTypes from 'prop-types';

import { MappingStatus } from './MappingStatus';
import { AlternateSource } from './AlternateSource';
import { TargetInstances } from './TargetInstances';

import { ALTERNATE_SOURCE_STATUS } from './constants';

const getAlternateSourceStatus = (alternateSourceId, communityId) => {
  if (!alternateSourceId) {
    return ALTERNATE_SOURCE_STATUS.UNSET;
  }

  return alternateSourceId === communityId
    ? ALTERNATE_SOURCE_STATUS.MATCH
    : ALTERNATE_SOURCE_STATUS.MISMATCH;
};

export const BooksMapping = ({
  booksMappings = {},
  communityId,
  propertyId,
}) => {
  const mappingStatus = booksMappings?.status;
  const alternateSourceId =
    booksMappings?.instance?.attributes?.alternateSourceId;
  const targetInstances = booksMappings?.mappings?.target_instances || [];

  const alternateSourceStatus = getAlternateSourceStatus(
    alternateSourceId,
    communityId
  );

  return (
    <React.Fragment>
      <MappingStatus propertyId={propertyId} mappingStatus={mappingStatus} />

      <div className="knock-react-flex input-auto">
        <div className="property-info-edit-field-label">PropertyId</div>
        <div className="property-info-edit-field-label">{propertyId}</div>
      </div>

      <AlternateSource
        alternateSourceId={alternateSourceId}
        status={alternateSourceStatus}
      />

      <TargetInstances targetInstances={targetInstances} />
    </React.Fragment>
  );
};

BooksMapping.propTypes = {
  booksMappings: PropTypes.shape({
    status: PropTypes.string,
    instance: PropTypes.shape({
      attributes: PropTypes.shape({
        alternateSourceId: PropTypes.string,
        isActive: PropTypes.bool,
        propertyInstanceId: PropTypes.number,
        propertyInstanceSourceId: PropTypes.string,
        source: PropTypes.string,
      }),
      id: PropTypes.string,
      type: PropTypes.string,
    }),
    mappings: PropTypes.shape({
      originated_instance: PropTypes.shape({
        property_id: PropTypes.string,
        source: PropTypes.string,
      }),
      target_instances: PropTypes.arrayOf(
        PropTypes.shape({
          property_id: PropTypes.string,
          source: PropTypes.string,
        })
      ),
    }),
  }).isRequired,
  communityId: PropTypes.string.isRequired,
  propertyId: PropTypes.number.isRequired,
};
